import { Injectable } from '@angular/core';
import { SortByEnum, SortOrderEnum } from '../entity-data/entity-data.data';
import { PaymentsSettings } from '../settings-data/sub-models/company-settings/payments.model';
import { DocumentPresetSettings } from '../settings-data/sub-models/document-preset-settings/document-preset-settings.model';
import {
  IExpensesMultipleSelectAdditionalProperties,
  IFtuAdditionalProperties,
  IInsightsHubAdditionalProperties,
  IItemsMultipleSelectAdditionalProperties,
  IPaymentOptionsAdditionalProperties,
  ISortOptionsAdditionalProperties,
  TrackingPaymentOptionsEnum,
} from './tracking.data';

@Injectable()
export class TrackingAdditionalPropertiesBuilder {
  buildPaymentOptions(
    paymentsSettings: PaymentsSettings,
    documentSettings: DocumentPresetSettings,
    revisionId: string,
    useI2gMoney: boolean
  ): IPaymentOptionsAdditionalProperties {
    let cardPayments: TrackingPaymentOptionsEnum;
    let paypalEc: TrackingPaymentOptionsEnum;
    let bankTransferDebit: TrackingPaymentOptionsEnum;
    let invoice2goMoney: TrackingPaymentOptionsEnum;

    // card payments
    if (!paymentsSettings.cardPaymentsEnabled()) {
      cardPayments = TrackingPaymentOptionsEnum.account_disabled;
    } else {
      cardPayments = documentSettings.cardPaymentsDisabled
        ? TrackingPaymentOptionsEnum.document_disabled
        : TrackingPaymentOptionsEnum.enabled;
    }

    // paypal
    if (!paymentsSettings.paypalEcEnabled) {
      paypalEc = TrackingPaymentOptionsEnum.account_disabled;
    } else {
      paypalEc = documentSettings.paypalEcDisabled
        ? TrackingPaymentOptionsEnum.document_disabled
        : TrackingPaymentOptionsEnum.enabled;
    }

    if (useI2gMoney) {
      // invoice2go money
      invoice2goMoney = documentSettings.bankTransferDisabled
        ? TrackingPaymentOptionsEnum.document_disabled
        : TrackingPaymentOptionsEnum.enabled;
    } else {
      // ach debit
      const achDebit = paymentsSettings.achDebit;

      if (
        achDebit.isUnderwritingRequired() ||
        achDebit.isDisabled() ||
        achDebit.isIneligible()
      ) {
        bankTransferDebit = TrackingPaymentOptionsEnum.account_disabled;
      } else {
        bankTransferDebit = documentSettings.bankTransferDisabled
          ? TrackingPaymentOptionsEnum.document_disabled
          : TrackingPaymentOptionsEnum.enabled;
      }
    }

    return {
      i2g_money: invoice2goMoney,
      bank_transfer_debit: bankTransferDebit,
      card_payments: cardPayments,
      paypal_ec: paypalEc,
      revision_id: revisionId,
    };
  }

  buildItemMultipleSelectOptions(
    itemCount: number
  ): IItemsMultipleSelectAdditionalProperties {
    return {
      count: itemCount,
    };
  }

  buildExpenseMultipleSelectOptions(
    expenseCount: number,
    withoutImages: boolean
  ): IExpensesMultipleSelectAdditionalProperties {
    return {
      count: expenseCount,
      without_images: withoutImages,
    };
  }

  buildSortOptions(
    sortBy: SortByEnum,
    sortOrder: SortOrderEnum
  ): ISortOptionsAdditionalProperties {
    // Using 'alphabetical' following tracking requirement for now.
    let sortByText;

    if (sortBy === SortByEnum.billing_name) {
      sortByText = 'alphabetical';
    } else {
      sortByText = sortBy;
    }

    return {
      sort_by: sortByText,
      order: sortOrder,
    };
  }

  buildFtuOptions(): IFtuAdditionalProperties {
    return {
      variant_key: 'ftuv1',
    };
  }

  buildInsightsHub(
    isEligibleForInsightsHubExperiment: boolean
  ): IInsightsHubAdditionalProperties {
    return {
      insights_hub: isEligibleForInsightsHubExperiment,
    };
  }
}
